import {useMutation} from "@tanstack/react-query";
import {editOfferTemplateNoteMutationOptions} from "./edit-offer-template-note.mutation-options";

export function useEditOfferTemplateNote(id: string, noteId: number) {
  return useMutation(editOfferTemplateNoteMutationOptions(id, noteId));
}
